import React, { useEffect, useState, memo } from "react";
import styled, { css } from "styled-components";
import { Icon } from "..";

interface SwitchWrapperProps {
  width?: string;
  height?: string;
  bgColor?: string;
  borderRadius?: string;
  switchSpace?: string;
}

export interface SwitchButtonProps {
  /**
   * What is the Switch Text
   */
  switchTxt?: {
    leftTxt: string;
    rightTxt: string;
  };
  /**
   * What is the Switch Width
   */
  width?: string;
  /**
   * What is the Switch Height
   */
  height?: string;
  /**
   * Optional click handler
   */
  onClick: (side: string) => void;
  activeSide?: string;
  leftColor?: string;
  rightColor?: string;
  withIcon?: boolean;
  leftIcon?: string;
  rightIcon?: string;
  bgColor?: string;
  borderRadius?: string;
  fontSize?: string;
  switchSpace?: string;
}

interface ISwitchText {
  leftColor?: string;
  rightColor?: string;
  borderRadius?: string;
  fontSize?: string;
}
/**
 * Switch Wrapper Span's Main
 */
const SwitchText = styled.span<ISwitchText>`
  font-size: ${(prop) => prop.fontSize};
  flex: 1 1 50%;
  justify-content: center;
  display: flex;
  height: 100%;
  border-radius: ${(prop) => prop.borderRadius};
  align-items: center;
  color: ${(theme: any) => theme.theme["Light1"]};
  cursor: pointer;
  &.active.leftSide {
    background-color: ${(prop) => prop.theme[prop.leftColor || "bgRed"]};
  }
  &.active.rightSide {
    background-color: ${(prop) => prop.theme[prop.rightColor || "bgPrimary"]};
    color: ${(theme: any) => theme.theme["btnColor"]};
  }
`;

/**
 * Switch Button Main Wrapper Styles
 */
const SwitchWrapper = styled.div<SwitchWrapperProps>`
  display: flex;
  padding: 5px;
  border-radius: ${(prop) => prop.borderRadius};
  width: ${(p) => p.width};
  height: ${(p) => p.height};
  position: relative;
  align-items: center;
  overflow: hidden;
  ${(p) =>
    p.bgColor &&
    css`
      background: ${(theme) => theme.theme[p.bgColor || "bgColor1"]};
    `};
  span {
    &:not(:first-child) {
      margin-right: ${(p) => p.switchSpace};
    }
  }
`;

const WithIconWrapper = styled.div`
  display: flex;
  cursor: pointer;
  width: 90px;
  padding: 10px;
  background-color: transparent;
  align-items: center;
  justify-content: space-around;
  &.Wactive {
    border-radius: 32px;
    background-color: ${(theme: any) => theme.theme["Light5"]};
  }
`;

const WithIconText = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
  text-align: center;
  color: ${(theme: any) => theme.theme["Light2"]};
  &.Wactive {
    color: ${(theme: any) => theme.theme["white"]};
  }
`;

/**
 * Main Switch Ui Component
 */
const SwitchButton: React.FC<SwitchButtonProps> = ({
  switchTxt = {
    leftTxt: "چپ",
    rightTxt: "راست",
  },
  width = "155px",
  height = "28px",
  onClick,
  activeSide = "leftSide",
  leftColor = "bgRed",
  rightColor = "blue",
  withIcon = false,
  leftIcon = "",
  rightIcon = "",
  bgColor = "bgColor1",
  borderRadius = "32px",
  fontSize = "12px",
  switchSpace = "0",
}) => {
  useEffect(() => {
    setMode(activeSide);
  }, [activeSide]);
  /**
   * Component Main State
   */
  const [mode, setMode] = useState<string>();
  const handleClick = (mode: string) => {
    setMode(mode);
    onClick(mode);
  };

  return (
    <SwitchWrapper
      width={width}
      switchSpace={switchSpace}
      height={height}
      bgColor={bgColor}
      borderRadius={borderRadius}
    >
      {!withIcon ? (
        <SwitchText
          borderRadius={borderRadius}
          fontSize={fontSize}
          rightColor={rightColor}
          onClick={() => handleClick("rightSide")}
          className={mode === "rightSide" ? "active rightSide" : ""}
        >
          {switchTxt.rightTxt}
        </SwitchText>
      ) : (
        <WithIconWrapper
          className={mode === "rightSide" ? "Wactive" : ""}
          onClick={() => handleClick("rightSide")}
        >
          <Icon name={rightIcon} width={"15px"} height={"15px"} />
          <WithIconText className={mode === "rightSide" ? "Wactive" : ""}>
            {switchTxt.rightTxt}
          </WithIconText>
        </WithIconWrapper>
      )}
      {!withIcon ? (
        <SwitchText
          borderRadius={borderRadius}
          fontSize={fontSize}
          leftColor={leftColor}
          onClick={() => handleClick("leftSide")}
          className={mode === "leftSide" ? "active leftSide" : ""}
        >
          {switchTxt.leftTxt}
        </SwitchText>
      ) : (
        <WithIconWrapper
          className={mode === "leftSide" ? "Wactive" : ""}
          onClick={() => handleClick("leftSide")}
        >
          <Icon name={leftIcon} width={"15px"} height={"15px"} />
          <WithIconText className={mode === "leftSide" ? "Wactive" : ""}>
            {switchTxt.leftTxt}
          </WithIconText>
        </WithIconWrapper>
      )}
    </SwitchWrapper>
  );
};

export default memo(SwitchButton);
